import createMaskInput from './Masked';

const mask = [/\d/, /\d/, /\d/, /\d/, /\d/];

export default createMaskInput({
    mask,
    showMask: false
});
